import { Link } from "@smart/itops-sb-design-system-dom";

import { DismissibleBanner } from "./banner";
import { useIntakeSettingsNavigation } from "../settings/navigate";

export const VoiceGuideBanner = () => {
  const { navigate } = useIntakeSettingsNavigation();

  return (
    <DismissibleBanner
      storageKey="dismissed-banner.voice-guide"
      content={
        <>
          Allow clients to hear questions read aloud and respond using their
          voice. Enable in{" "}
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <Link
            text="Intake Settings > Voice-Guide"
            onClick={() => navigate("voice-guide")}
          />
          .
        </>
      }
    />
  );
};
